import React, { useEffect, useRef } from 'react';
import pad from 'pad';


const Masterselected = ({ data = [] , errors, onSelected, name, reset }) => {

  const select = useRef();

  useEffect(() => {
    select.current.selectedIndex = 0;
  },[reset]);

  return (
      <select ref={select} onChange={(e) => onSelected(e, name)} className={`form-control input-border ${errors.name && "is-invalid"}`} name={name} disabled={data.length ? false : true}>
      <option value="null">Seleccione...</option>
      {data.map((guia, i) => {
        return <option key={i} value={guia.id}>{pad(5,guia.id,'0')} - {guia.rel_tipos.description} - {guia.description}</option>
      })}
      </select>
  )
};

export default Masterselected;